const webApps = [
	{
		id: 32,
		title: "React Weather App",
		url: "https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_40/v1621906984/weatherApp_z5rs3b.png",
		description:
			"This is a web app which provide the current weather situation of a selected city",
		liveDemo: "https://weatheroutlook.netlify.app/",
		github: "https://github.com/Mar-Issah/REACT-WEATHER-APP.git",
		tags: [
			"VSC",
			"Git",
			"HTML5",
			"CSS3",
			"ES6",
			"React.js ",
			" Bootstrap",
			"Weather API"
		],
	},
	{
		id: 31,
		title: "PERN Todo-List",
		url: "https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_25/v1640111319/My%20Website%20Projects/pern_todlist_oiknvt.png",
		description:
			"A web application which allows user to create, edit and delete their todo list",
		liveDemo: "https://todonote.netlify.app",
		github: "https://github.com/Mar-Issah/PERN-Todo-List.git",
		tags: [
			"VSC",
			"Git",
			"HTML5",
			"CSS3",
			"JavaScript",
			" ES6",
			"React.js ",
			"Node.js",
			"Express.js",
			"React Bootstrap",
			"PostgresSQL",
		],
	},
	{
		id: 2,
		title: "React Exercise Tracker",
		url: "https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_20/v1617839139/My%20Website%20Projects/react_extracker_bl5xp8.png",
		description:
			"A web application which allows user to create and store username and exercises (description, duration and date)",
		liveDemo: "https://exerciselogger.netlify.app/",
		github: "https://github.com/Mar-Issah/React-Exercise-Tracker",
		tags: [
			"VSC",
			"HTML5",
			"CSS3 ",
			"MongoDb",
			"Node.js",
			"ES6 ",
			"React.js",
			"Express.js ",
			"Git ",
			"JavaScript",
			"Bootstrap",
		],
	},
	{
		id: 1,
		title: "Pomodoro Clock",
		url: "https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_25/v1617412489/My%20Website%20Projects/pomodoro_clock_ep2eew.png",
		description:
			"This is a clock that gives you a prescribed interval of 25 minutes of work followed by a 5-minute break",
		liveDemo: "https://codepen.io/marsiya-issah/full/GRNdrrr",
		github: "https://github.com/Mar-Issah/Pomodoro-Clock",
		tags: [
			"VSC",
			"Git",
			"HTML5",
			"CSS3",
			"ES6",
			"React.js ",
			"Node.js",
			"JavaScript",
			" Material Icons",
		],
	},
	{
		id: 3,
		title: "Random Quote Machine",
		url: "https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_20/v1617297529/My%20Website%20Projects/random_quote_machine_twdozo.png",
		description:
			"A web application which displays random quotes made by famous people",
		liveDemo: "https://codepen.io/marsiya-issah/full/xxRgjZq",
		github: "https://github.com/Mar-Issah/Random-Quote-Machine",
		tags: [
			"VSC",
			"Git",
			"HTML5",
			"CSS3",
			"SASS",
			"JavaScript",
			"ES6",
			"Node.js",
			"React.js",
			"Bootstrap",
		],
	},
	{
		id: 4,
		title: "Markdown Previewer",
		url: "https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_20/v1617387767/My%20Website%20Projects/markdown_nkf2lr.png",
		description:
			"This is a web application converts and preview markdown text to HTML",
		liveDemo: "https://codepen.io/marsiya-issah/full/qBqPExB",
		github: "https://github.com/Mar-Issah/Markdown-Previewer-",
		tags: [
			"VSC",
			"HTML5",
			"CSS3",
			"Node.js",
			"JavaScript ",
			"ES6",
			" React.js",
			"Git",
			"Bootstrap",
		],
	},
	{
		id: 5,
		title: "The Drum Machine",
		url: "https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_20/v1617411021/My%20Website%20Projects/drum_machine_kj715r.png",
		description:
			"An electronic musical instrument that creates percussion sounds and drum beats as you press or click on the keys",
		liveDemo: "https://codepen.io/marsiya-issah/full/vYyewqR",
		github: "https://github.com/Mar-Issah/Drum-Machine",
		tags: [
			"VSC",
			"HTML5 ",
			"CSS3 ",
			"JavaScript ",
			"ES6",
			"Node.js",
			"React.js",
			"Git",
			"Bootstrap",
			"Font Awesome",
		],
	},
	{
		id: 6,
		title: "My Grocery List",
		url: "https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_20/v1617543115/My%20Website%20Projects/grocery_list2_sccjhi.png",
		description:
			"This app allows you to create and manage grocery/ shopping list on your computer",
		liveDemo: "https://codepen.io/marsiya-issah/full/ZELyEZb",
		github: "https://github.com/Mar-Issah/Grocery-List",
		tags: [
			"VSC",
			"HTML5 ",
			"CSS3 ",
			"JavaScript ",
			"ES6",
			"JQuery",
			"Git",
			"Font Awesome",
		],
	},
	{
		id: 7,
		title: "Sales Countdown Timer",
		url: "https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_20/v1617237028/My%20Website%20Projects/sales_countdown_timer_jkgdxj.png",
		description:
			"This displays sales countdown timer in single product page . The clocks run every second until time elapses",
		liveDemo: "https://codepen.io/mar-issah/full/YzdxGPQ",
		github: "https://github.com/Mar-Issah/Sales-Countdown-Timer",
		tags: ["VSC", "HTML5 ", "CSS3 ", "JavaScript ", "ES6", "Git"],
	},
	{
		id: 8,
		title: "Lorem Ipsum Text Generator",
		url: "https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_20/v1617221377/My%20Website%20Projects/lorem_text_gen.3_suhvi4.png",
		description:
			"Easily generate Lorem Ipsum placeholder text for your project in any number of paragraphs",
		liveDemo: "https://codepen.io/marsiya-issah/full/ZEpyPYE",
		github: "https://github.com/Mar-Issah/Lorem-Ipsum-Text-Generator",
		tags: ["VSC", "HTML5 ", "CSS3 ", "JavaScript ", "ES6", "Git"],
	},
	{
		id: 9,
		title: "Fashion and Clothing Store",
		url: "https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_20/v1617550765/My%20Website%20Projects/Ecommerce%20-%20simple/ecommerce_dlbve7.png",
		description:
			"This is a simple web application which displays items available in a store from women, men and kids clothes and accessories",
		liveDemo: "https://codepen.io/marsiya-issah/full/eYgRNMP",
		github: "https://github.com/Mar-Issah/Fashion-and-Clothing-Store",
		tags: ["VSC", "HTML5 ", "CSS3 ", "JavaScript ", "ES6", "Git"],
	},
	{
		id: 10,
		title: "Custom JavaScript Navbar",
		url: "https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_25/v1617670370/My%20Website%20Projects/Navbar_w9grrl.png",
		description:
			"Custom navbar project using pure JavaScript which diplays nav menu and a toggle button when on small screen which when clicked expands/closes the navbar",
		liveDemo: "https://codepen.io/marsiya-issah/full/vYgJEXR",
		github: "https://github.com/Mar-Issah/Custom-JavaScript-Navbar",
		tags: [
			"VSC",
			"HTML5 ",
			"CSS3 ",
			"JavaScript ",
			"ES6",
			"Font Awesome",
			"Git",
		],
	},
	{
		id: 11,
		title: "Custom JavaScript Sidebar",
		url: "https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_25/v1617644297/My%20Website%20Projects/sidebar_sq8vgr.png",
		description:
			"A pure JavaScript single page sidebar web app which diplays a menu sidebar when the toggle button is clicked. The sidebar is closed when the close button is clicked",
		liveDemo: "https://codepen.io/marsiya-issah/full/WNROLYQ",
		github: "https://github.com/Mar-Issah/Custom-Sidebar-Menu",
		tags: [
			"VSC",
			"HTML5 ",
			"CSS3 ",
			"JavaScript ",
			"ES6",
			"Font Awesome",
			"Git",
		],
	},
	{
		id: 12,
		title: "Custom JavaScript Accordion",
		url: "https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_25/v1617668381/My%20Website%20Projects/question_ipk0ag.png",
		description:
			"A useful way to squeeze lots of page content into a small space. It consists of a list of items, of which only one is expanded at any one time",
		liveDemo: "https://codepen.io/marsiya-issah/full/poRrzKp",
		github: "https://github.com/Mar-Issah/Custom-JavaScript-Accordion",
		tags: [
			"VSC",
			"HTML5 ",
			"CSS3 ",
			"JavaScript ",
			"ES6",
			"Font Awesome",
			"Git",
		],
	},
	{
		id: 13,
		title: "Custom JavaScript Tabs",
		url: "https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_25/v1617638019/My%20Website%20Projects/just_about_bhduck.png",
		description:
			"A pure JavaScript single about page web app which displays diferent content as you click on the tabs",
		liveDemo: "https://codepen.io/marsiya-issah/full/abpwRPx",
		github: "https://github.com/Mar-Issah/Custom-JavaScipt-Tabs",
		tags: ["VSC", "HTML5 ", "CSS3 ", "JavaScript ", "ES6", "Git"],
	},
	{
		id: 14,
		title: "Custom JavaScript Pre-loader and Video player",
		url: "https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_75/v1619356605/My%20Website%20Projects/video2_vyqxea.png",
		description:
			"This diplays a preloader on load and after displys a video player with buttons to play or pause the video",
		liveDemo: "https://codepen.io/marsiya-issah/full/BapZGqP",
		github: "https://github.com/Mar-Issah/Custom-pre-loader-and-video-player",
		tags: [
			"VSC",
			"HTML5 ",
			"CSS3 ",
			"JavaScript ",
			"ES6",
			"Font Awesome",
			"Git",
		],
	},
	{
		id: 15,
		title: "C++ Hospital Management System",
		url: "https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_20/v1616550506/Hospital-Mgt-Sys2_znyqu3.png",
		description:
			"A simple console application that helps manage the information related to health care and health care providers",
		liveDemo: "",
		github: "https://github.com/Mar-Issah/Hospital-Management-System",
		tags: ["Code::Blocks", "C++"],
	},
	{
		id: 16,
		title: "Exercise Tracker",
		url: "https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_30/v1617817803/My%20Website%20Projects/ex_tracker_rflftm.png",
		description:
			"A web application which allows user to create and store username and exercises (description, duration and date)",
		liveDemo: "https://marsiya-fcc-extracker.glitch.me/",
		github: "https://github.com/Mar-Issah/Exercise-Tracker--FCC",
		tags: [
			"Glitch",
			"HTML5",
			"CSS3 ",
			"Git ",
			"MongoDb",
			"Node.js",
			"ES6 ",
			"Express.js ",
			"JavaScript",
		],
	},
	{
		id: 17,
		title: "Request Header Parser Microservice",
		url: "https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_25/v1617756559/My%20Website%20Projects/header_parser_ug3te7.png",
		description: `A request to "api/whoami" and gives you back a JSON with IP address, preferred language and browser software.`,
		liveDemo: "https://marsiya-fcc-headerparser.glitch.me",
		github:
			"https://github.com/Mar-Issah/Request-Header-Parser-Microservice-FCC",
		tags: [
			"Glitch",
			"HTML5",
			"CSS3 ",
			"Git ",
			"Node.js",
			"ES6 ",
			"Express.js ",
			"JavaScript",
		],
	},
	{
		id: 18,
		title: "File Metadata Microservice",
		url: "https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_25/v1617832379/My%20Website%20Projects/file_metadata_ofzq3v.png",
		description:
			"File Metadata Microservice project allows you to submit a file and receive the file name, type, and size in bytes within the JSON response",
		liveDemo: "https://marsiya-file-metadata.glitch.me",
		github: "https://github.com/Mar-Issah/File-Metadata-Microservice-FCC",
		tags: [
			"Glitch",
			"HTML5",
			"CSS3 ",
			"Git ",
			"Node.js",
			"ES6 ",
			"Express.js ",
			"JavaScript",
		],
	},
	{
		id: 19,
		title: "URL Shortener Microservice",
		url: "https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_60/v1617807639/My%20Website%20Projects/url_shortner_tpmsqq.png",
		description: `You can POST a URL to /api/shorturl and get a JSON response with original url and short url`,
		liveDemo: "https://marsiya-fcc-url.glitch.me",
		github: "https://github.com/Mar-Issah/URL-Shortener-Microservice-FCC",
		tags: [
			"Glitch",
			"HTML5",
			"CSS3 ",
			"Git ",
			"MongoDb",
			"Node.js",
			"ES6 ",
			"Express.js ",
			"JavaScript",
		],
	},
	{
		id: 20,
		title: "Timestamp Microservice",
		url: "https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_25/v1617745655/My%20Website%20Projects/timestamp_microservice_zyakm6.png",
		description:
			"This app takes a date string and gives you back a JSON with Unix value which is the time in milliseconds and UTC format for the given date",
		liveDemo: "https://marsiya-fcc-timestamp.glitch.me",
		github: "https://github.com/Mar-Issah/Timestamp-Microservice-FCC",
		tags: [
			"Glitch",
			"HTML5",
			"CSS3 ",
			"Git ",
			"MongoDb",
			"Node.js",
			"ES6 ",
			"Express.js ",
			"JavaScript",
		],
	},
	{
		id: 21,
		title: "Travel 2021",
		url: "https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_20/v1617292175/My%20Website%20Projects/travel_2021_meiwch.png",
		description:
			"This is a slideshow for cycling through list of countries to visit. The surprise me button randomly selects a country",
		liveDemo: "https://codepen.io/marsiya-issah/full/gOwREXB",
		github: "https://github.com/Mar-Issah/Travel-2021",
		tags: ["VSC", "HTML5", "CSS3 ", "Git ", "ES6 ", "JavaScript"],
	},
	{
		id: 22,
		title: "Personal Portfolio Webpage",
		url: "https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_30/v1617298125/My%20Website%20Projects/personal_port_wlenpr.png",
		description: "A Personal Portfolio Webpage built with pure HTML5 and CSS3",
		liveDemo: "https://codepen.io/marsiya-issah/full/JjROdPB",
		github: "https://github.com/Mar-Issah/Personal-Portfolio-Webpage",
		tags: ["VSC", "HTML5", "CSS3 ", "Git"],
	},
	{
		id: 23,
		title: "Counter",
		url: "https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_20/v1617294765/My%20Website%20Projects/counter_cm5tov.png",
		description:
			"Manually click on the increase button to increase counts , decrease button to decrease counts or the reset button to clear the counts and set to zero",
		liveDemo: "https://codepen.io/marsiya-issah/full/dyNvMbP",
		github: "https://github.com/Mar-Issah/My-Counter",
		tags: ["VSC", "HTML5", "CSS3", "JavaScript", "Git"],
	},
	{
		id: 24,
		title: "React Calculator",
		url: "https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_20/v1617482527/My%20Website%20Projects/React_Calculator_jnhdfw.png",
		description:
			"A simple react calculator. A replica of ios calcultor User Interface",
		liveDemo: "https://codepen.io/marsiya-issah/full/MWbVENq",
		github: "https://github.com/Mar-Issah/React-Calculator",
		tags: [
			"VSC",
			"HTML5",
			"CSS3",
			"JavaScript",
			"React.js",
			"Bootstrap",
			"Git",
		],
	},
	{
		id: 25,
		title: "JavaScript Calculator",
		url: "https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_20/v1617240680/My%20Website%20Projects/js_calculator_rb1uvj.png",
		description: "A calculator built with JavaScript",
		liveDemo: "https://codepen.io/marsiya-issah/full/PoGKWpB",
		github: "https://github.com/Mar-Issah/JavaScript-Calculator",
		tags: ["VSC", "HTML5", "CSS3", "JavaScript", "Git"],
	},
	{
		id: 26,
		title: "Technical Documentation Page",
		url: "https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_20/v1617069577/My%20Website%20Projects/C_aeyuuw.png",
		description:
			"A simple C# technical documentation page built with HTML5 and CSS3",
		liveDemo: "https://codepen.io/marsiya-issah/full/MWjwbEN",
		github: "https://github.com/Mar-Issah/CSharp-technical-documentation-page",
		tags: ["VSC", "HTML5", "CSS3", "Git"],
	},
	{
		id: 27,
		title: "Survey Form",
		url: "https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_30/v1617069569/My%20Website%20Projects/survey_form_u2pma0.png",
		description: "A sample survey UI built with HTML5 and CSS3",
		liveDemo: "https://codepen.io/marsiya-issah/full/OJXdEWz",
		github: "https://github.com/Mar-Issah/Survey-form-FreeCodeCamp",
		tags: ["VSC", "HTML5", "CSS3", "Git"],
	},
	{
		id: 28,
		title: "Tribute Page",
		url: "https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_20/v1617066924/My%20Website%20Projects/Dr._Kwame_Nkrumah_gi05cw.png",
		description:
			"A tribute page for Dr. Kwame Nkrumah, the man who led Ghana to achieve independence",
		liveDemo: "https://codepen.io/marsiya-issah/full/bGeLPZN",
		github:
			"https://github.com/Mar-Issah/Tribute-Page-FreeCodeCamp-Curriculum-",
		tags: ["VSC", "HTML5", "CSS3", "Git"],
	},
	{
		id: 29,
		title: "Product Landing Page",
		url: "https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_20/v1617069563/My%20Website%20Projects/epilators_bwgl6o.png",
		description: "An Epilator landing page built with HTML5 and CSS3",
		liveDemo: "https://codepen.io/marsiya-issah/full/vYKqKBG",
		github: "https://github.com/Mar-Issah/Product-Landing-Page---FreeCodeCamp",
		tags: ["VSC", "HTML5", "CSS3", "Git"],
	},
	{
		id: 30,
		title: "",
		url: "https://",
		description: "more awesome app coming soon...",
		liveDemo: "https://",
		github: "https://",
		tags: [],
	},
];

export default webApps;
